module.exports = __webpack_public_path__ + "img/0220624174317.adf37dd9.png";